import React from 'react';
import logo from '../../assets/logo.png';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from "react";

function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
    const location = useLocation();
    
    useEffect(() => {
        const handleScroll = () => {
          setScrolled(window.scrollY > 50); // change at 50px
        };
    
        const handleResize = () => {
          setIsDesktop(window.innerWidth >= 768);
        };
    
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);
        return () => {
          window.removeEventListener("scroll", handleScroll);
          window.removeEventListener("resize", handleResize);
        };
      }, []);
    return (
        <div className="row align-items-center py-3" style={{
            position: isDesktop ? "fixed" : "relative",
            width: "-webkit-fill-available",
            top: isDesktop ? 0 : "auto",
            zIndex: isDesktop ? 1000 : "auto",
            transition: "background-color 0.3s ease",
            backgroundColor: scrolled && isDesktop ? "rgba(0, 0, 0, 0.85)" : "transparent",
          }}
        >
         <div className="col-12 col-md-3 text-center text-md-start mb-2 mb-md-0 ps-md-5">
  <Link to="/">
    <img 
      src={logo} 
      alt="Logo" 
      className="img-fluid" 
      style={{ maxWidth: '150px', cursor: 'pointer' }} 
    />
  </Link>
</div>

            <div className="col-12 col-md-6">
                <div className="row justify-content-md-start ps-md-5 ms-md-5 justify-content-center text-center text-md-end">
                    <div className="col-auto">
                        <Link 
                            to="/" 
                            className="fw-semibold mb-0 text-white text-decoration-none"
                            onClick={(e) => {
                                if (location.pathname === '/') {
                                    e.preventDefault();
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }
                            }}
                        >
                            Home
                        </Link>
                    </div>
                    <div className="col-auto">
                        <Link
                            to="/"
                            className="fw-semibold mb-0 text-white text-decoration-none"
                            onClick={() => {
                                setTimeout(() => {
                                    const el = document.getElementById('earn');
                                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                                }, 100); // Delay to ensure navigation
                            }}
                        >
                            Earn
                        </Link>
                    </div>
                    <div className="col-auto">
                        <Link
                            to="/"
                            className="fw-semibold mb-0 text-white text-decoration-none"
                            onClick={() => {
                                setTimeout(() => {
                                    const el = document.getElementById('ride');
                                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                                }, 100); // Delay to ensure navigation
                            }}
                        >
                            Ride
                        </Link>
                    </div>
                    
                    <div className="col-auto">
                        <Link
                            to="/"
                            className="fw-semibold mb-0 text-white text-decoration-none"
                            onClick={() => {
                                setTimeout(() => {
                                    const el = document.getElementById('business');
                                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                                }, 100); // Delay to ensure navigation
                            }}
                        >
                            Corporate
                        </Link>
                    </div>
                    <div className="col-auto">
                        <Link 
                            to="/about" 
                            className="fw-semibold mb-0 text-white text-decoration-none"
                            onClick={(e) => {
                                if (location.pathname === '/about') {
                                    e.preventDefault();
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }
                            }}
                        >
                            Our Story
                        </Link>
                    </div>
                   <div className="col-auto">
  <a
    href="https://shield.rolotransit.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="fw-semibold mb-0 text-white text-decoration-none"
  >
    RoloShield
  </a>
</div>
                </div>
            </div>
            <div className="col-12 col-md-3">
                {/* <div className="row justify-content-md-start justify-content-center text-center text-md-end">
                    <div className="col-auto">
                        <Link
                            to="/"
                            className="fw-semibold mb-0 text-white text-decoration-none"
                            onClick={() => {
                                setTimeout(() => {
                                    const el = document.getElementById('ride');
                                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                                }, 100); // Delay to ensure navigation
                            }}
                        >
                            Language
                        </Link>
                    </div>
                    <div className="col-auto">
                        <Link
                            to="/"
                            className="fw-semibold mb-0 text-white text-decoration-none"
                            onClick={() => {
                                setTimeout(() => {
                                    const el = document.getElementById('earn');
                                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                                }, 100); // Delay to ensure navigation
                            }}
                        >
                            Login
                        </Link>
                    </div>
                    <div className="col-auto">
                        <Link
                            to="/"
                            className="fw-semibold mb-0 text-white text-decoration-none"
                            onClick={() => {
                                setTimeout(() => {
                                    const el = document.getElementById('business');
                                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                                }, 100); // Delay to ensure navigation
                            }}
                        >
                            Signup
                        </Link>
                    </div>
                </div> */}
            </div>
        </div>
    );
}

export default Navbar;